import src from "IMAGE";
export default { src, width: 309, height: 80, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADMLOFAtCzFGGhQbHTY2Ni47OzsyPDw8NDg4ODA8PDw0AEw6UFRINktPHhofHTo6OjI4ODgwQEBANzo6OjE+Pj41piQNaog2IhAAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
